module.exports = __webpack_public_path__ + "media/images/sp/stores/horie/horie_concept_01-499f3f9dc13f30009ad08bc24169d1d2.jpg";